// extracted by mini-css-extract-plugin
export default {"roadmap":"Roadmap_roadmap__KgirF","roads":"Roadmap_roads__bvA6A","road":"Roadmap_road__YJI88","line":"Roadmap_line__DurtB"};